export enum MetaSteps {
  first = 'first',
  last = 'last',
}

export enum BooleanQuestionValues {
  yes = 'yes',
  no = 'no',
}

export enum CarValues {
  volvo = 'volvo',
  kia = 'kia',
}
